import React from 'react';
import styled from 'styled-components';
import { useAuth } from '../../shared/hooks/useApi/useAuth';
import { useSetting } from '../../shared/hooks/useApi/useSetting';
import MoleculeDivToggle from '../../shared/component/molecule/MoleculeDivToggle';
import { getSettingsMessage } from '../../shared/constants/pageMessages';
import { SubContainer, SubExplain, SubTitle, SubWrapper, Title } from './MemberSetting';

const Notification: React.FC = () => {
  const { user } = useAuth();
  const { setting, updateNotification } = useSetting();

  if (!user || !setting) return null;

  const handleMarketingEmailChange = async (value: boolean) => {
    await updateNotification({
      marketingEmail: value
    });
  };

  return (
    <MemberSettingComp>
      <Title>Notification</Title>
      <SubContainer>
        <SubWrapper>
          <SubTitle>{getSettingsMessage('SETTINGS_MARKETING')}
            <SubExplain>
              {getSettingsMessage('MARKETING_EMAIL_EXPLAIN')}
            </SubExplain>
          </SubTitle>
          <MoleculeDivToggle
            value={Boolean(setting.marketingEmail)}
            name={"Email"}
            handleToggle={(e) => handleMarketingEmailChange(e.target.checked)}
          />
        </SubWrapper>
      </SubContainer>
    </MemberSettingComp>
  );
}

const MemberSettingComp = styled.section`
  width: clamp(320px, 65%, 650px);
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

export default Notification;